import {createRouter, createWebHistory} from 'vue-router'
import routes from "./routes";
import {AuthCheck, getStorageToken} from "@/mixins/Auth";
import {setAuthInHeader} from "@/api/request";
import {localStorageKey} from "@/api/config.js";
import AutoLoginCheckIn from "@/mixins/autoLoginCheckIn.js";
import store from "@/store";

// 라우터 정의
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: routes,
})

let isInitialRouteEnter = true;

const ensureLiveChannelDisplay = (force = false) => Promise.all([
    store.dispatch('common/ensureLiveChannelDisplay', {platform: 'WEB', force}),
]);

const syncLiveChannelDisplayOnRoute = async () => {
    const token = getStorageToken();
    if (!token) {
        return;
    }

    if (isInitialRouteEnter) {
        isInitialRouteEnter = false;
        await ensureLiveChannelDisplay(true);
        return;
    }

    await ensureLiveChannelDisplay(false);
};

router.beforeEach(async function (to, from, next) {
    if (to.matched.some(routeInfo => routeInfo.meta.authRequired)) {
        const status = AuthCheck();

        if (status === 1) {
            const token = getStorageToken();
            setAuthInHeader(token);
            await syncLiveChannelDisplayOnRoute();

            const autoLogin = new AutoLoginCheckIn();
            autoLogin.autoLoginCheckIn();
            window.localStorage.removeItem(localStorageKey + 'qrAuth');

            return next();
        }

        return next({
            path: "/auth",
            query: { redirect: to.fullPath },
        });
    }

    await syncLiveChannelDisplayOnRoute();

    return next();
});


export default router;
